import { SmartComponentPropertyDetails } from "./smart-component-property-details";

/**
 * Property of a smart component.
 * A "Property" of a SmartComponent object associates to the Skills of that particular instance a "mask" of values
 */
export class SmartComponentProperty {
  public id: number = 0;
  public name: string = "";
  public informalName: string = "";
  public idSmartComponentKind: number = 0;
  public skills: SmartComponentPropertyDetails[] = [];

  constructor(controlType?: any) {
    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}

/**
 * Address details used for smart component
 */
export class AddressDetails {
  public id: number = 0;
  public address: string = "";
  public instanceGUID: string = "";
  public measureUnit: string = "";

  constructor(controlType?: any) {
    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}

export class AddressFunctionDetails {
  public id: number = 0;
  public name: string = "";

  constructor(controlType?: any) {
    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}
